import classNames from "classnames/bind";
import styles from "./AciCard.module.css";

const cx = classNames.bind(styles);

export default function AciCard({ item }) {
  return (
    <div className={cx("aciCard", "card", "liftUp")}>
      <div className={cx("imgBox")}>
        <img src={item.image} alt={item.company} />
      </div>

      <div className={cx("company")}>{item.company}</div>

      <div className={cx("row")}>
        <span>업종</span>
        <strong>{item.industry}</strong>
      </div>

      <div className={cx("row")}>
        <span>목적물</span>
        <strong>{item.purposeObject}</strong>
      </div>

      <div className={cx("row")}>
        <span>피해규모</span>
        <strong className={cx("highlight")}>{item.damageScale}</strong>
      </div>

      <div className={cx("tag")}>{item.businessField}</div>
    </div>
  );
}
